import { useQuery } from 'react-query'

import { QUERY_KEYS } from '../../api'
import { CarriersApi } from './api'
import { Carrier } from '../../types'

interface UseCarriersFiltersOutput {
  carriersFilters: Carrier[] | undefined
  carriersFiltersIsLoading: boolean
}

const useCarriersFilters = (): UseCarriersFiltersOutput => {
  const { data: carriersFilters, isLoading: carriersFiltersIsLoading } = useQuery(
    [QUERY_KEYS.CARRIERS],
    () =>
      CarriersApi.getCarriersWithFilters({
        filters: { limit: 400 },
      }).then(response => response.carriers),
  )

  return { carriersFilters, carriersFiltersIsLoading }
}
export default useCarriersFilters
